type DuplicateField = 'full_name_latin' | 'full_name_local' | 'phone' | 'email';

export const getDuplicatedData = (
  value: string,
  field: DuplicateField,
  data?: { [key in DuplicateField]?: string | string[] } | null
) => {
  switch (field) {
    case 'full_name_latin':
    case 'full_name_local':
      return data?.[field] === value;
    case 'phone':
    case 'email':
      return data?.[field]?.includes(value);
  }
};
